import { render, staticRenderFns } from "./FolderOfferFile.vue?vue&type=template&id=14bf5276&scoped=true"
import script from "./FolderOfferFile.vue?vue&type=script&lang=js"
export * from "./FolderOfferFile.vue?vue&type=script&lang=js"
import style0 from "./FolderOfferFile.vue?vue&type=style&index=0&id=14bf5276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bf5276",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
